<template>
  <div class="image-captcha">
    <input
      ref="input"
      type="text"
      :placeholder="placeholder"
      v-model="data"
      autocomplete="off"
      :disabled="disabled"
      :maxlength="maxlength"
      @blur="blur"
      @change="keyup"
    />
    <img
      :src="captchaImageUrl"
      @click="refresh($event)" />
  </div>
</template>

<script>
/* eslint-disable*/
import Schema from 'async-validator';
import {captchaImageUrl} from '@/service';

export default {
  name: 'AuthFormImageCaptcha',
  props: {
    maxlength: Number,
    placeholder: {
      type: String,
    },
    rule: {
      type: [Object, Array],
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: [String, Number],
  },
  data() {
    return {
      data: '',
      validator: null,
      message: '',
      captchaImageUrl: captchaImageUrl + this.$store.state.system.deviceId,
      smsBtnText: '获取验证码',
      smsBtnDisabled: false,
    };
  },
  watch: {
    value(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.data = n;
    },
  },
  methods: {
    check() {
      return new Promise((resolve) => {
        this.validate().then(() => {
          this.$emit('validator', true);
          resolve(true);
        }, (msg) => {
          this.$emit('validator', msg);
          resolve(false);
        });
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.data}, (err) => {
          if (err) {
            reject(err[0].message);
          } else {
            resolve();
          }
        });
      });
    },
    refresh(e) {
      e.target.src = e.target.src;
    },
    keyup() {
      this.$emit('input', this.data);
    },
    blur() {
      this.validate().then(() => {
        this.$emit('validator', true);
      }, (msg) => {
        this.$emit('validator', msg);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  input {
    color: rgba(0,0,0,.45);
  }
</style>
